import { keymap, EditorView } from '@codemirror/view';
import { defaultKeymap, history, historyKeymap, indentWithTab } from '@codemirror/commands';
import { markdown, markdownLanguage } from '@codemirror/lang-markdown';
import { languages } from '@codemirror/language-data';
import { syntaxHighlighting, defaultHighlightStyle, bracketMatching } from '@codemirror/language';
import { closeBrackets } from '@codemirror/autocomplete';
import { searchKeymap, highlightSelectionMatches } from '@codemirror/search';
import { EditorState } from '@codemirror/state';
import { bearTheme } from './editorTheme';
import { livePreviewPlugin } from './livePreview';

function toggleWrapper(view, wrapper) {
  const { state } = view;
  const { from, to } = state.selection.main;
  const selectedText = state.doc.sliceString(from, to);

  if (selectedText.startsWith(wrapper) && selectedText.endsWith(wrapper) && selectedText.length >= wrapper.length * 2) {
    // Remove wrapper
    view.dispatch({
      changes: { from, to, insert: selectedText.slice(wrapper.length, -wrapper.length) }
    });
  } else {
    // Add wrapper
    view.dispatch({
      changes: { from, to, insert: `${wrapper}${selectedText}${wrapper}` }
    });
  }
}

export function createEditorExtensions(onSave) {
  const saveKeymap = keymap.of([
    {
      key: 'Mod-s',
      run: () => {
        if (onSave) onSave();
        return true;
      }
    },
    {
      key: 'Mod-b',
      run: (view) => {
        toggleWrapper(view, '**');
        return true;
      }
    },
    {
      key: 'Mod-i',
      run: (view) => {
        toggleWrapper(view, '*');
        return true;
      }
    },
  ]);

  return [
    bearTheme,
    history(),
    markdown({ base: markdownLanguage, codeLanguages: languages }),
    syntaxHighlighting(defaultHighlightStyle),
    bracketMatching(),
    closeBrackets(),
    highlightSelectionMatches(),
    livePreviewPlugin,
    saveKeymap,
    keymap.of([
      indentWithTab,
      ...defaultKeymap,
      ...historyKeymap,
      ...searchKeymap,
    ]),
    EditorView.lineWrapping,
    EditorState.allowMultipleSelections.of(true),
  ];
}
